<div class="grid_container">
  <div class="image_container quadrant main">
    <ng-container *ngIf="isServer; else lazyBrowserTpl">
      <img
        class="main_image skeleton skeleton-image-large first-render"
        src="https://storage.hostelhop.io/images/resize/[[SSR_DATA_IMAGE_MAIN]]?width=420"
        srcset="https://storage.hostelhop.io/images/resize/[[SSR_DATA_IMAGE_MAIN]]?width=420 420w,
          https://storage.hostelhop.io/images/resize/[[SSR_DATA_IMAGE_MAIN]]?width=700 700w,
          https://storage.hostelhop.io/images/resize/[[SSR_DATA_IMAGE_MAIN]]?width=960 960w"
        sizes="(max-width: 420px) 420px, (max-width: 700px) 700px, 960px"
        fetchPriority="high"
        alt="">
    </ng-container>
    <ng-template #lazyBrowserTpl>
      <ng-container *ngIf="coverImage">
        <img ngOptimizedImage class="main_image"
          [ngSrc]="coverImage.fileName"
          ngSrcset="420w, 700w, 960w"
          sizes="(max-width: 420px) 420px, (max-width: 700px) 700px, 960px"
          [priority]="true"
          [fill]="true"
          alt="">
        </ng-container>
    </ng-template>
  </div>
  <div class="image_quadrants">
    <ng-container *ngIf="!hostel || !isBrowser">
      <div class="quadrant">
        <img class="skeleton skeleton-image-small">
      </div>
      <div class="quadrant top_right">
        <img class="skeleton skewleton-image-small top_right">
      </div>
      <div class="quadrant">
        <img class="skeleton skeleton-image-small">
      </div>
      <div class="quadrant bottom_right">
        <img class="skeleton skeleton-image-small bottom_right">
      </div>
    </ng-container>
    
    <!-- Loop through images -->
    <div class="quadrant" *ngFor="let image of top4Images; let i = index; trackBy: trackByFileName"
      [class.top_right]="i === 1"
      [class.bottom_right]="i === 3">
      
      <!-- If last image and totalImages > 5, overlay button -->
      <ng-container *ngIf="i === 3 && totalImages > 5; else normalImage">
        <div class="overlay_image">
          <img ngOptimizedImage [ngSrc]="image.fileName"
               [fill]="true"
               ngSrcset="420w"
               sizes="420w"
               alt="">
          <button class="view-all-photos" (click)="openModal()">View all photos</button>
        </div>
      </ng-container>

      <!-- Normal image for all others -->
      <ng-template #normalImage>
        <img ngOptimizedImage [ngSrc]="image.fileName"
             [fill]="true"
             ngSrcset="420w"
             sizes="420w"
             alt="">
      </ng-template>
    </div>
  </div>
  <div class="modal" *ngIf="isModalOpen" (click)="clickOutside($event)">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <span class="close" (click)="closeModal()">&times;</span>
  
      <!-- Carousel of images -->
      <div class="carousel">
        <button class="carousel-control-prev" (click)="previousImage()">&#10094;</button>
        <div class="carousel-images">
          <!-- Reuse the same logic you used for loading images in the grid -->
          <img 
          class="carousel-image"
            ngOptimizedImage
            [ngSrc]="currentImage"
            ngSrcset="420w"
            sizes="420w"
            [fill]="true"
            alt="Image Carousel"
          />
        </div>
        <button class="carousel-control-next" (click)="nextImage()">&#10095;</button>
      </div>
    </div>
  </div>
  
</div>
